import { Typography, type BodyTextProps } from "@packages/ds";
import styled from "styled-components";

export interface TdProps extends BodyTextProps {
  width: string | number;
}

export const Layout = styled(Typography.BodyText).attrs((props: TdProps) => ({
  as: "div",
  weight: props.weight || "semibold",
  size: props.size || "small"
}))<TdProps>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;

  ${({ width }) => width && `flex-basis: ${width};`};
`;
